import { render, staticRenderFns } from "./Attributecol.vue?vue&type=template&id=5b74fee8"
import script from "./Attributecol.vue?vue&type=script&lang=js"
export * from "./Attributecol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports